// 多个角色/多个地方用到才放到这边
// 字段映射
export const premiumPlanFieldMap = {
    0: WordList.ProperAllTextOff,
    1: WordList.ProperAllTextNormal,
    2: WordList.ProperAllTextExpired,
    3: WordList.Inactived
};
export const activeFieldMap = {
    0: WordList.ProperAllTextInactive,
    1: WordList.ProperAllTextNormal,
    2: WordList.ProperAllTextExpired
};
